import { isActionData, isAnAlertChoice, isChoice } from '90.quickConnect.Models/guards';
import mapChoiceListFromString from '90.quickConnect.Models/mappings/sharedList/mapChoiceListFromString';
import { Choice } from '90.quickConnect.Models/models';

export default function mapAllFieldTypeValuesToChoice(nextValue: unknown): Choice | null | undefined {
  let result: Choice | undefined;

  if (isAnAlertChoice(nextValue) || isChoice(nextValue)) result = { ...nextValue };
  else if (typeof nextValue === 'string') {
    const list = mapChoiceListFromString(nextValue);
    return list.length > 0 ? list[0] : null;
  } else if (isActionData(nextValue)) {
    const [first] = nextValue;

    const { value } = first;

    return Array.isArray(value) ? value[0] : value;
  } else if (nextValue === null || nextValue === '') return null;

  return result;
}
